var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    stroke: "#A8A8A8",
    rx: 3,
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526173",
    d: "M19.434 13.101l-1.118-1.119-4.75 4.75 4.75 4.75 1.118-1.119-3.63-3.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 26V7h19v19z"
  }))));
}
export default __webpack_public_path__ + "img/3e2e936cae7ac842015d0019e10d4612.svg";
export { SvgBackButton as ReactComponent };